/* tslint:disable */
/* eslint-disable */
/**
 * 1paper APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import Store from '../store';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

export interface ConfirmRetranslationResponse {
    'id'?: number;
    'state': string;
}
/**
 * ※ エンタープライズの翻訳回数更新時の回数用。コメント見る感じ、おそらく一時対応用。Membership にまとめちゃっても良さそう。
 */
export interface Contract {
    /**
     * ユーザ ID（`User.id`）
     */
    'user_id': number;
    /**
     * 翻訳回数更新時の回数。エンタープライズは毎月この回数にリセットされる。<br/> -1 の場合は翻訳回数無制限。
     */
    'quota': number;
}
export interface ErrorReportRequest {
    'user_id': number;
    'usage_id': number;
}
export interface EvaluateTranslationRequest {
    'score': number;
    'comment'?: string;
}
export interface Evaluation {
    'id': number;
    /**
     * 翻訳履歴 ID（`Usage.id`）
     */
    'usage_id': number;
    /**
     * スコア（1 ～ 5）
     */
    'score'?: number;
    /**
     * コメント
     */
    'comment'?: string;
    /**
     * 登録日時
     */
    'registered_at': string;
}
export interface GetEnterpriseQuota {
    'consumedUsages'?: number;
    'contractedUsages'?: number;
}
/**
 * エンタープライズ管理画面で表示するユーザー情報の一覧用のモデル
 */
export interface GetEnterpriseUsers {
    /**
     * ユーザーID
     */
    'user_id': number;
    /**
     * ユーザーの表示名
     */
    'username'?: string;
    /**
     * 氏名(姓)
     */
    'first_name'?: string;
    /**
     * 氏名(名)
     */
    'last_name'?: string;
    /**
     * 累積翻訳本数
     */
    'quota_sum'?: number;
    /**
     * 月間平均翻訳本数
     */
    'quota_avg'?: number;
    /**
     * 最近翻訳した論文のタイトル
     */
    'latest_paper_title'?: string;
    /**
     * 最近翻訳した論文の概要
     */
    'latest_paper_abstract'?: string;
    /**
     * 最近翻訳した論文のサムネイル
     */
    'latest_paper_image'?: string;
}
export interface GetMyPlan {
    'code': string;
    'name': string;
    'quota'?: number;
    'has_annotation'?: boolean;
    'is_ocr_enabled'?: boolean;
    'price'?: number;
    'applied'?: boolean;
    'consuming_word_count'?: number;
    'stripe'?: GetMyPlanStripe;
    'add_purchase_payment_code'?: string;
}
export interface GetMyPlanStripe {
    'pk': string;
    'payment_code': string;
}
export interface GetMyProfileResponse {
    'profile': Profile;
    'membership': GetMyProfileResponseMembership;
    'organization'?: string;
}
export interface GetMyProfileResponseMembership {
    'quota': number;
    'contract_renewal_date': string;
    'plan': GetMyProfileResponseMembershipPlan;
    'contract'?: number;
}
export interface GetMyProfileResponseMembershipPlan {
    /**
     * コード
     */
    'code': string;
    /**
     * プラン名（日本語）
     */
    'name': string;
    /**
     * stripeで月額購入の識別用コード
     */
    'payment_code'?: string;
    /**
     * 翻訳回数更新時の回数（エンタープライズは *Contract* で管理）
     */
    'quota'?: number;
    /**
     * 原文注釈の有無
     */
    'has_annotation'?: boolean;
    /**
     * OCR の可否
     */
    'is_ocr_enabled'?: boolean;
    /**
     * 月額料金（表示用）
     */
    'price'?: number;
    /**
     * 翻訳文字数の上限。-1 だと無制限
     */
    'consuming_word_count'?: number;
    /**
     * 有効フラグ。無効（false）のものはプラン一覧に表示されない
     */
    'enabled'?: boolean;
    /**
     * stripeで回数追加の商品名
     */
    'add_purchase_product_name'?: string;
    /**
     * stripeで回数追加の識別用コード
     */
    'add_purchase_payment_code'?: string;
    'is_free'?: boolean;
}
export interface GetMyUsage {
    'id': number;
    'translation_file': string;
    'translated_file'?: string;
    'uploaded_at'?: string;
    'status'?: number;
    'consumed_quota'?: number;
    'consumed_word_count'?: number;
    'is_ocr_used'?: boolean;
    'err_state'?: string;
    'err_message'?: string;
    'api_version'?: string;
    'source_lang'?: string;
    'target_lang'?: string;
    'title_original'?: string;
    'title_translated'?: string;
    'abstract'?: string;
    'image'?: string;
    'user_id'?: number;
    'user_last_name'?: string;
    'user_first_name'?: string;
    'save_name'?: string;
    'total_chars'?: number;
}
export interface InquiryRequest {
    'type': InquiryTypeEnum;
    'email': string;
    'comment': string;
    'usage_id'?: number;
}



export const InquiryTypeEnum = {
    AboutTranslationError: 'AboutTranslationError',
    AboutEnterprisePlan: 'AboutEnterprisePlan',
    AboutOthers: 'AboutOthers',
} as const;

export type InquiryTypeEnum = typeof InquiryTypeEnum[keyof typeof InquiryTypeEnum];


export interface LoginRequest {
    'identifier': string;
    'password': string;
}
export interface LoginResponse {
    'token': string;
}
export interface Membership {
    /**
     * ユーザ ID（`User.id`）
     */
    'user_id': number;
    /**
     * プランコード（`Plan.code`）
     */
    'plan_code': string;
    /**
     * 翻訳残回数
     */
    'quota'?: number;
    /**
     * stripe の決済完了時のコード（スタンダード・アカデミックのみ）
     */
    'subscription_code'?: string;
    /**
     * 翻訳回数の次回更新日時
     */
    'contract_renewal_date'?: string;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
}
export interface Organization {
    /**
     * 組織ID
     */
    'id': number;
    /**
     * 組織名称
     */
    'name': string;
    /**
     * プランコード（`Plan.code`）
     */
    'plan_code': string;
    /**
     * stripe の決済完了時のコード（未使用）
     */
    'subscription_code'?: string;
    /**
     * 翻訳回数の次回更新日時
     */
    'contract_renewal_date'?: string;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
}
export interface OrganizationContract {
    'id': number;
    /**
     * 組織 ID（`Organization.id`）
     */
    'organization_id': number;
    /**
     * 契約した翻訳回数
     */
    'quota': number;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
}
export interface OrganizationMembership {
    'id': number;
    /**
     * 組織 ID（`Organization.id`）
     */
    'organization_id': number;
    /**
     * ユーザ ID（`User.id`）
     */
    'user_id': number;
    /**
     * 翻訳した回数
     */
    'quota'?: number;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
}
export interface Plan {
    /**
     * コード
     */
    'code': string;
    /**
     * プラン名（日本語）
     */
    'name': string;
    /**
     * stripeで月額購入の識別用コード
     */
    'payment_code'?: string;
    /**
     * 翻訳回数更新時の回数（エンタープライズは *Contract* で管理）
     */
    'quota'?: number;
    /**
     * 原文注釈の有無
     */
    'has_annotation'?: boolean;
    /**
     * OCR の可否
     */
    'is_ocr_enabled'?: boolean;
    /**
     * 月額料金（表示用）
     */
    'price'?: number;
    /**
     * 翻訳文字数の上限。-1 だと無制限
     */
    'consuming_word_count'?: number;
    /**
     * 有効フラグ。無効（false）のものはプラン一覧に表示されない
     */
    'enabled'?: boolean;
    /**
     * stripeで回数追加の商品名
     */
    'add_purchase_product_name'?: string;
    /**
     * stripeで回数追加の識別用コード
     */
    'add_purchase_payment_code'?: string;
}

export const PlanEnum = {
    Free: 'free',
    Trial: 'trial',
    Academic: 'academic',
    Standard: 'standard',
    Enterprise: 'enterprise',
} as const;

export type PlanEnum = typeof PlanEnum[keyof typeof PlanEnum];


export interface Profile {
    'id': number;
    /**
     * ユーザ名
     */
    'username': string;
    /**
     * メールアドレス
     */
    'email': string;
    /**
     * 名
     */
    'first_name'?: string;
    /**
     * 姓
     */
    'last_name'?: string;
    /**
     * 所属
     */
    'belongs_to'?: string;
    /**
     * 住所
     */
    'address'?: string;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
    /**
     * 権限種別（`Role.name`）
     */
    'role_name'?: string;
}
export interface RegisterRequest {
    'username': string;
    'email': string;
    'first_name'?: string;
    'last_name'?: string;
    'belongs_to': string;
    'address'?: string;
    'password': string;
}
export interface RemindRequest {
    'identifier': string;
}
export interface RequestVerificationRequest {
    'identifier': string;
}
export interface ResetRequest {
    'password': string;
}
export interface Role {
    'id': number;
    /**
     * 権限名
     */
    'name': string;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
}
export interface StripeAddPurchaseRequest {
    'livemode'?: boolean;
    'type'?: StripeAddPurchaseRequestTypeEnum;
    'data'?: StripeAddPurchaseRequestData;
}

export const StripeAddPurchaseRequestTypeEnum = {
    CheckoutSessionCompleted: 'checkout.session.completed',
} as const;

export type StripeAddPurchaseRequestTypeEnum = typeof StripeAddPurchaseRequestTypeEnum[keyof typeof StripeAddPurchaseRequestTypeEnum];

export interface StripeAddPurchaseRequestData {
    'object'?: StripeAddPurchaseRequestDataObject;
}
export interface StripeAddPurchaseRequestDataObject {
    'mode': StripeAddPurchaseRequestDataObjectModeEnum;
    'amount_total': number;
    'customer_email': string;
    'metadata'?: StripeAddPurchaseRequestDataObjectMetadata;
}

export const StripeAddPurchaseRequestDataObjectModeEnum = {
    Payment: 'payment',
} as const;

export type StripeAddPurchaseRequestDataObjectModeEnum = typeof StripeAddPurchaseRequestDataObjectModeEnum[keyof typeof StripeAddPurchaseRequestDataObjectModeEnum];

export interface StripeAddPurchaseRequestDataObjectMetadata {
    'quantity': number;
}
export interface StripePaymentSessionRequest {
    'quantity': number;
}
export interface StripeRequest {
    'livemode'?: boolean;
    'type'?: StripeRequestTypeEnum;
    'data'?: StripeRequestData;
}

export const StripeRequestTypeEnum = {
    InvoicePaid: 'invoice.paid',
} as const;

export type StripeRequestTypeEnum = typeof StripeRequestTypeEnum[keyof typeof StripeRequestTypeEnum];

export interface StripeRequestData {
    'object'?: StripeRequestDataObject;
}
export interface StripeRequestDataObject {
    'customer': string;
    'customer_email': string;
    'subscription': string;
    'lines': StripeRequestDataObjectLines;
}
export interface StripeRequestDataObjectLines {
    'data': Array<StripeRequestDataObjectLinesDataInner>;
}
export interface StripeRequestDataObjectLinesDataInner {
    'period': StripeRequestDataObjectLinesDataInnerPeriod;
    'price': StripeRequestDataObjectLinesDataInnerPrice;
}
export interface StripeRequestDataObjectLinesDataInnerPeriod {
    'start': number;
    'end': number;
}
export interface StripeRequestDataObjectLinesDataInnerPrice {
    'id': string;
    'product': string;
}
export interface StripeSessionResponse {
    'url': string;
}
export interface StripeSubscriptionSessionRequest {
    'plan_code': string;
}
export interface UpdateEnterpriseProfileRequest {
    'user_id'?: number;
    'email'?: string;
    'first_name'?: string;
    'last_name'?: string;
    'belongs_to'?: string;
    'address'?: string;
    'password'?: string;
}
export interface UpdateMyProfileRequest {
    'email'?: string;
    'first_name'?: string;
    'last_name'?: string;
    'belongs_to'?: string;
    'address'?: string;
    'password'?: string;
}
export interface UploadFileResponse {
    'id': number;
}
export interface Usage {
    'id': number;
    /**
     * ユーザ ID（`User.id`）
     */
    'user_id': number;
    /**
     * 翻訳対象の PDF ファイル名
     */
    'translation_file': string;
    /**
     * 翻訳対象の PDF のハッシュ値
     */
    'translation_hash'?: string;
    /**
     * 翻訳実行時のパラメータ
     */
    'translation_params': string;
    /**
     * 翻訳結果のファイル名（ファイル名自体は使われていない）
     */
    'translated_file'?: string;
    /**
     * 翻訳文字数
     */
    'consumed_word_count'?: number;
    /**
     * OCR 使用有無
     */
    'is_ocr_used'?: boolean;
    /**
     * OCRの強制の有無
     */
    'force_ocr'?: boolean;
    /**
     * エラー状態 0:その他 1:要OCR
     */
    'err_state'?: string;
    /**
     * エラーメッセージ
     */
    'err_message'?: string;
    /**
     * 翻訳元言語
     */
    'source_lang'?: string;
    /**
     * 翻訳先言語
     */
    'target_lang'?: string;
    /**
     * translateAPIのバージョン
     */
    'api_version'?: string;
    /**
     * 翻訳実行日時
     */
    'uploaded_at': string;
    /**
     * 翻訳完了日時（エラー終了時も含む）
     */
    'result_at'?: string;
    /**
     * 翻訳ステータス - *200* : 完了（ダウンロード済み） - *201* : 完了（未ダウンロード） - *202* : 翻訳中 - *40x* : エラー
     */
    'status'?: number;
    /**
     * 翻訳回数の消費回数（※ 現状未使用。10 万文字毎のカウントアップに使用する予定）
     */
    'consumed_quota'?: number;
    /**
     * 翻訳対象のタイトル（原文）
     */
    'title_original'?: string;
    /**
     * 翻訳対象のタイトル（訳文）
     */
    'title_translated'?: string;
    /**
     * 翻訳対象の abstract（訳文）
     */
    'abstract'?: string;
    /**
     * 翻訳対象のサムネイル用画像
     */
    'image'?: string;
    /**
     * 保存名
     */
    'save_name'?: string;
    /**
     * 総文字数
     */
    'total_chars'?: number;
}
export interface User {
    'id': number;
    /**
     * ユーザ名
     */
    'username': string;
    /**
     * メールアドレス
     */
    'email': string;
    /**
     * 名
     */
    'first_name'?: string;
    /**
     * 姓
     */
    'last_name'?: string;
    /**
     * 所属
     */
    'belongs_to'?: string;
    /**
     * 住所
     */
    'address'?: string;
    /**
     * 登録日時
     */
    'registered_at': string;
    /**
     * 更新日時
     */
    'updated_at': string;
    /**
     * 権限種別（`Role.name`）
     */
    'role_name'?: string;
    /**
     * ハッシュ化されたパスワード
     */
    'hash_password': string;
    /**
     * 認証済みフラグ。メールアドレス認証後に true になる
     */
    'verified': boolean;
    /**
     * 有効フラグ。退会時の論理削除に使う（予定）
     */
    'enabled': boolean;
}

/**
 * EnterpriseApi - axios parameter creator
 * @export
 */
export const EnterpriseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download a file of same organization user
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEnterpriseUserFile: async (usageId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('downloadEnterpriseUserFile', 'usageId', usageId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('downloadEnterpriseUserFile', 'authorization', authorization)
            const localVarPath = `/enterprise/files/{usage_id}`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a user\'s profile in company
         * @param {number} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseProfile: async (userId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEnterpriseProfile', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEnterpriseProfile', 'authorization', authorization)
            const localVarPath = `/enterprise/{user_id}/profile`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 消費済み本数と契約本数の取得を行うAPI
         * @summary Get consumed usages
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseQuota: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEnterpriseQuota', 'authorization', authorization)
            const localVarPath = `/enterprise/quota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a enterprise user\'s usage history
         * @param {number} userId 
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseUsages: async (userId: number, authorization: string, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEnterpriseUsages', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEnterpriseUsages', 'authorization', authorization)
            const localVarPath = `/enterprise/{user_id}/usages`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a translated html url of same organization user
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseUserHtmlFileUrl: async (usageId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('getEnterpriseUserHtmlFileUrl', 'usageId', usageId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEnterpriseUserHtmlFileUrl', 'authorization', authorization)
            const localVarPath = `/enterprise/files/{usage_id}/html`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * トークンに含まれるユーザー情報より組織IDを解決し、 組織メンバーの最近の利用状況を取得するためのAPI
         * @summary Get enterprise users list
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseUsers: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEnterpriseUsers', 'authorization', authorization)
            const localVarPath = `/enterprise/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user\'s profile
         * @param {string} authorization 
         * @param {UpdateEnterpriseProfileRequest} updateEnterpriseProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterpriseProfile: async (authorization: string, updateEnterpriseProfileRequest: UpdateEnterpriseProfileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateEnterpriseProfile', 'authorization', authorization)
            // verify required parameter 'updateEnterpriseProfileRequest' is not null or undefined
            assertParamExists('updateEnterpriseProfile', 'updateEnterpriseProfileRequest', updateEnterpriseProfileRequest)
            const localVarPath = `/enterprise/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnterpriseProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnterpriseApi - functional programming interface
 * @export
 */
export const EnterpriseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnterpriseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download a file of same organization user
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEnterpriseUserFile(usageId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEnterpriseUserFile(usageId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a user\'s profile in company
         * @param {number} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseProfile(userId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseProfile(userId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 消費済み本数と契約本数の取得を行うAPI
         * @summary Get consumed usages
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseQuota(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnterpriseQuota>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseQuota(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a enterprise user\'s usage history
         * @param {number} userId 
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseUsages(userId: number, authorization: string, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMyUsage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseUsages(userId, authorization, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a translated html url of same organization user
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseUserHtmlFileUrl(usageId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseUserHtmlFileUrl(usageId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * トークンに含まれるユーザー情報より組織IDを解決し、 組織メンバーの最近の利用状況を取得するためのAPI
         * @summary Get enterprise users list
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseUsers(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEnterpriseUsers>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseUsers(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a user\'s profile
         * @param {string} authorization 
         * @param {UpdateEnterpriseProfileRequest} updateEnterpriseProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnterpriseProfile(authorization: string, updateEnterpriseProfileRequest: UpdateEnterpriseProfileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnterpriseProfile(authorization, updateEnterpriseProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnterpriseApi - factory interface
 * @export
 */
export const EnterpriseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnterpriseApiFp(configuration)
    return {
        /**
         * 
         * @summary Download a file of same organization user
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEnterpriseUserFile(usageId: number, authorization: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadEnterpriseUserFile(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a user\'s profile in company
         * @param {number} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseProfile(userId: number, authorization: string, options?: any): AxiosPromise<GetMyProfileResponse> {
            return localVarFp.getEnterpriseProfile(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 消費済み本数と契約本数の取得を行うAPI
         * @summary Get consumed usages
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseQuota(authorization: string, options?: any): AxiosPromise<GetEnterpriseQuota> {
            return localVarFp.getEnterpriseQuota(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a enterprise user\'s usage history
         * @param {number} userId 
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseUsages(userId: number, authorization: string, page?: number, options?: any): AxiosPromise<Array<GetMyUsage>> {
            return localVarFp.getEnterpriseUsages(userId, authorization, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a translated html url of same organization user
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseUserHtmlFileUrl(usageId: number, authorization: string, options?: any): AxiosPromise<string> {
            return localVarFp.getEnterpriseUserHtmlFileUrl(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * トークンに含まれるユーザー情報より組織IDを解決し、 組織メンバーの最近の利用状況を取得するためのAPI
         * @summary Get enterprise users list
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseUsers(authorization: string, options?: any): AxiosPromise<Array<GetEnterpriseUsers>> {
            return localVarFp.getEnterpriseUsers(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user\'s profile
         * @param {string} authorization 
         * @param {UpdateEnterpriseProfileRequest} updateEnterpriseProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterpriseProfile(authorization: string, updateEnterpriseProfileRequest: UpdateEnterpriseProfileRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateEnterpriseProfile(authorization, updateEnterpriseProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnterpriseApi - object-oriented interface
 * @export
 * @class EnterpriseApi
 * @extends {BaseAPI}
 */
export class EnterpriseApi extends BaseAPI {
    /**
     * 
     * @summary Download a file of same organization user
     * @param {number} usageId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public downloadEnterpriseUserFile(params: { usageId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['usageId'] = params['usageId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).downloadEnterpriseUserFile(_params.usageId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a user\'s profile in company
     * @param {number} userId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getEnterpriseProfile(params: { userId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['userId'] = params['userId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).getEnterpriseProfile(_params.userId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 消費済み本数と契約本数の取得を行うAPI
     * @summary Get consumed usages
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getEnterpriseQuota(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).getEnterpriseQuota(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a enterprise user\'s usage history
     * @param {number} userId 
     * @param {string} authorization 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getEnterpriseUsages(params: { userId: number, authorization?: string, page?: number,  }, options?: any) {
				const _params = {} as any;
				_params['userId'] = params['userId']
				_params['authorization'] = params['authorization']
				_params['page'] = params['page']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).getEnterpriseUsages(_params.userId, _params.authorization, _params.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a translated html url of same organization user
     * @param {number} usageId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getEnterpriseUserHtmlFileUrl(params: { usageId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['usageId'] = params['usageId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).getEnterpriseUserHtmlFileUrl(_params.usageId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * トークンに含まれるユーザー情報より組織IDを解決し、 組織メンバーの最近の利用状況を取得するためのAPI
     * @summary Get enterprise users list
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getEnterpriseUsers(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).getEnterpriseUsers(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user\'s profile
     * @param {string} authorization 
     * @param {UpdateEnterpriseProfileRequest} updateEnterpriseProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateEnterpriseProfile(params: { authorization?: string, updateEnterpriseProfileRequest: UpdateEnterpriseProfileRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['updateEnterpriseProfileRequest'] = params['updateEnterpriseProfileRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return EnterpriseApiFp(this.configuration).updateEnterpriseProfile(_params.authorization, _params.updateEnterpriseProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * MyApi - axios parameter creator
 * @export
 */
export const MyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary authenticate
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auth: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('auth', 'authorization', authorization)
            const localVarPath = `/my/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel the logged in user\'s plan
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMyPlan: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cancelMyPlan', 'authorization', authorization)
            const localVarPath = `/my/plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check translation status
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTranslationStatus: async (usageId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('checkTranslationStatus', 'usageId', usageId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('checkTranslationStatus', 'authorization', authorization)
            const localVarPath = `/my/files/{usage_id}/status`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirmation of the need for retranslation
         * @param {boolean} forceOcr 
         * @param {string} authorization 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRetranslation: async (forceOcr: boolean, authorization: string, file: File, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forceOcr' is not null or undefined
            assertParamExists('confirmRetranslation', 'forceOcr', forceOcr)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('confirmRetranslation', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('confirmRetranslation', 'file', file)
            const localVarPath = `/my/files/retranslate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forceOcr !== undefined) {
                localVarQueryParameter['force_ocr'] = forceOcr;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create stripe payment session and return url
         * @param {string} authorization 
         * @param {StripePaymentSessionRequest} stripePaymentSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentSession: async (authorization: string, stripePaymentSessionRequest: StripePaymentSessionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createStripePaymentSession', 'authorization', authorization)
            // verify required parameter 'stripePaymentSessionRequest' is not null or undefined
            assertParamExists('createStripePaymentSession', 'stripePaymentSessionRequest', stripePaymentSessionRequest)
            const localVarPath = `/my/payment_session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripePaymentSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create stripe subscription session and return url
         * @param {string} authorization 
         * @param {StripeSubscriptionSessionRequest} stripeSubscriptionSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscriptionSession: async (authorization: string, stripeSubscriptionSessionRequest: StripeSubscriptionSessionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createStripeSubscriptionSession', 'authorization', authorization)
            // verify required parameter 'stripeSubscriptionSessionRequest' is not null or undefined
            assertParamExists('createStripeSubscriptionSession', 'stripeSubscriptionSessionRequest', stripeSubscriptionSessionRequest)
            const localVarPath = `/my/subscription_session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripeSubscriptionSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a file
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMyFile: async (usageId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('downloadMyFile', 'usageId', usageId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('downloadMyFile', 'authorization', authorization)
            const localVarPath = `/my/files/{usage_id}`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Evaluate translation
         * @param {string} authorization 
         * @param {number} usageId 
         * @param {EvaluateTranslationRequest} evaluateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateTranslation: async (authorization: string, usageId: number, evaluateTranslationRequest: EvaluateTranslationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('evaluateTranslation', 'authorization', authorization)
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('evaluateTranslation', 'usageId', usageId)
            // verify required parameter 'evaluateTranslationRequest' is not null or undefined
            assertParamExists('evaluateTranslation', 'evaluateTranslationRequest', evaluateTranslationRequest)
            const localVarPath = `/my/usages/{usage_id}/evaluations`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateTranslationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a translated html url
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHtmlFileUrl: async (usageId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('getMyHtmlFileUrl', 'usageId', usageId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyHtmlFileUrl', 'authorization', authorization)
            const localVarPath = `/my/files/{usage_id}/html`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of plans a user can apply
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPlans: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyPlans', 'authorization', authorization)
            const localVarPath = `/my/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a logged in user\'s profile
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyProfile: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyProfile', 'authorization', authorization)
            const localVarPath = `/my/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a logged in user\'s usage record
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUsage: async (usageId: number, authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('getMyUsage', 'usageId', usageId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyUsage', 'authorization', authorization)
            const localVarPath = `/my/usages/{usage_id}`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a logged in user\'s usage history
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {boolean} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUsages: async (authorization: string, page?: number, all?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyUsages', 'authorization', authorization)
            const localVarPath = `/my/usages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/my/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary logout
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('logout', 'authorization', authorization)
            const localVarPath = `/my/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary remind password
         * @param {RemindRequest} remindRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remind: async (remindRequest: RemindRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'remindRequest' is not null or undefined
            assertParamExists('remind', 'remindRequest', remindRequest)
            const localVarPath = `/my/remind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remindRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset passsword
         * @param {string} authorization 
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reset: async (authorization: string, resetRequest: ResetRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('reset', 'authorization', authorization)
            // verify required parameter 'resetRequest' is not null or undefined
            assertParamExists('reset', 'resetRequest', resetRequest)
            const localVarPath = `/my/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user\'s profile
         * @param {string} authorization 
         * @param {UpdateMyProfileRequest} updateMyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile: async (authorization: string, updateMyProfileRequest: UpdateMyProfileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateMyProfile', 'authorization', authorization)
            // verify required parameter 'updateMyProfileRequest' is not null or undefined
            assertParamExists('updateMyProfile', 'updateMyProfileRequest', updateMyProfileRequest)
            const localVarPath = `/my/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file
         * @param {string} sourceLang 
         * @param {string} targetLang 
         * @param {boolean} forceOcr 
         * @param {string} authorization 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyFile: async (sourceLang: string, targetLang: string, forceOcr: boolean, authorization: string, file: File, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceLang' is not null or undefined
            assertParamExists('uploadMyFile', 'sourceLang', sourceLang)
            // verify required parameter 'targetLang' is not null or undefined
            assertParamExists('uploadMyFile', 'targetLang', targetLang)
            // verify required parameter 'forceOcr' is not null or undefined
            assertParamExists('uploadMyFile', 'forceOcr', forceOcr)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadMyFile', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMyFile', 'file', file)
            const localVarPath = `/my/files/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sourceLang !== undefined) {
                localVarQueryParameter['source_lang'] = sourceLang;
            }

            if (targetLang !== undefined) {
                localVarQueryParameter['target_lang'] = targetLang;
            }

            if (forceOcr !== undefined) {
                localVarQueryParameter['force_ocr'] = forceOcr;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyApi - functional programming interface
 * @export
 */
export const MyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary authenticate
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auth(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auth(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel the logged in user\'s plan
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMyPlan(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMyPlan(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check translation status
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkTranslationStatus(usageId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkTranslationStatus(usageId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirmation of the need for retranslation
         * @param {boolean} forceOcr 
         * @param {string} authorization 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmRetranslation(forceOcr: boolean, authorization: string, file: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmRetranslationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmRetranslation(forceOcr, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create stripe payment session and return url
         * @param {string} authorization 
         * @param {StripePaymentSessionRequest} stripePaymentSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripePaymentSession(authorization: string, stripePaymentSessionRequest: StripePaymentSessionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripePaymentSession(authorization, stripePaymentSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create stripe subscription session and return url
         * @param {string} authorization 
         * @param {StripeSubscriptionSessionRequest} stripeSubscriptionSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripeSubscriptionSession(authorization: string, stripeSubscriptionSessionRequest: StripeSubscriptionSessionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripeSubscriptionSession(authorization, stripeSubscriptionSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download a file
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMyFile(usageId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMyFile(usageId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Evaluate translation
         * @param {string} authorization 
         * @param {number} usageId 
         * @param {EvaluateTranslationRequest} evaluateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateTranslation(authorization: string, usageId: number, evaluateTranslationRequest: EvaluateTranslationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateTranslation(authorization, usageId, evaluateTranslationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a translated html url
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyHtmlFileUrl(usageId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyHtmlFileUrl(usageId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of plans a user can apply
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPlans(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMyPlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPlans(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a logged in user\'s profile
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyProfile(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyProfile(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a logged in user\'s usage record
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyUsage(usageId: number, authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyUsage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyUsage(usageId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a logged in user\'s usage history
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {boolean} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyUsages(authorization: string, page?: number, all?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMyUsage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyUsages(authorization, page, all, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary logout
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary remind password
         * @param {RemindRequest} remindRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remind(remindRequest: RemindRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remind(remindRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset passsword
         * @param {string} authorization 
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reset(authorization: string, resetRequest: ResetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reset(authorization, resetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a user\'s profile
         * @param {string} authorization 
         * @param {UpdateMyProfileRequest} updateMyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyProfile(authorization: string, updateMyProfileRequest: UpdateMyProfileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyProfile(authorization, updateMyProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload a file
         * @param {string} sourceLang 
         * @param {string} targetLang 
         * @param {boolean} forceOcr 
         * @param {string} authorization 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMyFile(sourceLang: string, targetLang: string, forceOcr: boolean, authorization: string, file: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyFile(sourceLang, targetLang, forceOcr, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MyApi - factory interface
 * @export
 */
export const MyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MyApiFp(configuration)
    return {
        /**
         * 
         * @summary authenticate
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auth(authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.auth(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel the logged in user\'s plan
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMyPlan(authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelMyPlan(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check translation status
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTranslationStatus(usageId: number, authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.checkTranslationStatus(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirmation of the need for retranslation
         * @param {boolean} forceOcr 
         * @param {string} authorization 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRetranslation(forceOcr: boolean, authorization: string, file: File, options?: any): AxiosPromise<ConfirmRetranslationResponse> {
            return localVarFp.confirmRetranslation(forceOcr, authorization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create stripe payment session and return url
         * @param {string} authorization 
         * @param {StripePaymentSessionRequest} stripePaymentSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentSession(authorization: string, stripePaymentSessionRequest: StripePaymentSessionRequest, options?: any): AxiosPromise<StripeSessionResponse> {
            return localVarFp.createStripePaymentSession(authorization, stripePaymentSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create stripe subscription session and return url
         * @param {string} authorization 
         * @param {StripeSubscriptionSessionRequest} stripeSubscriptionSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscriptionSession(authorization: string, stripeSubscriptionSessionRequest: StripeSubscriptionSessionRequest, options?: any): AxiosPromise<StripeSessionResponse> {
            return localVarFp.createStripeSubscriptionSession(authorization, stripeSubscriptionSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a file
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMyFile(usageId: number, authorization: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadMyFile(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Evaluate translation
         * @param {string} authorization 
         * @param {number} usageId 
         * @param {EvaluateTranslationRequest} evaluateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateTranslation(authorization: string, usageId: number, evaluateTranslationRequest: EvaluateTranslationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.evaluateTranslation(authorization, usageId, evaluateTranslationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a translated html url
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHtmlFileUrl(usageId: number, authorization: string, options?: any): AxiosPromise<string> {
            return localVarFp.getMyHtmlFileUrl(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of plans a user can apply
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPlans(authorization: string, options?: any): AxiosPromise<Array<GetMyPlan>> {
            return localVarFp.getMyPlans(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a logged in user\'s profile
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyProfile(authorization: string, options?: any): AxiosPromise<GetMyProfileResponse> {
            return localVarFp.getMyProfile(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a logged in user\'s usage record
         * @param {number} usageId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUsage(usageId: number, authorization: string, options?: any): AxiosPromise<GetMyUsage> {
            return localVarFp.getMyUsage(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a logged in user\'s usage history
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {boolean} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUsages(authorization: string, page?: number, all?: boolean, options?: any): AxiosPromise<Array<GetMyUsage>> {
            return localVarFp.getMyUsages(authorization, page, all, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: any): AxiosPromise<LoginResponse> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary logout
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.logout(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary remind password
         * @param {RemindRequest} remindRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remind(remindRequest: RemindRequest, options?: any): AxiosPromise<void> {
            return localVarFp.remind(remindRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset passsword
         * @param {string} authorization 
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reset(authorization: string, resetRequest: ResetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.reset(authorization, resetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user\'s profile
         * @param {string} authorization 
         * @param {UpdateMyProfileRequest} updateMyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile(authorization: string, updateMyProfileRequest: UpdateMyProfileRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateMyProfile(authorization, updateMyProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file
         * @param {string} sourceLang 
         * @param {string} targetLang 
         * @param {boolean} forceOcr 
         * @param {string} authorization 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyFile(sourceLang: string, targetLang: string, forceOcr: boolean, authorization: string, file: File, options?: any): AxiosPromise<UploadFileResponse> {
            return localVarFp.uploadMyFile(sourceLang, targetLang, forceOcr, authorization, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyApi - object-oriented interface
 * @export
 * @class MyApi
 * @extends {BaseAPI}
 */
export class MyApi extends BaseAPI {
    /**
     * 
     * @summary authenticate
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public auth(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).auth(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel the logged in user\'s plan
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public cancelMyPlan(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).cancelMyPlan(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check translation status
     * @param {number} usageId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public checkTranslationStatus(params: { usageId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['usageId'] = params['usageId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).checkTranslationStatus(_params.usageId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirmation of the need for retranslation
     * @param {boolean} forceOcr 
     * @param {string} authorization 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public confirmRetranslation(params: { forceOcr: boolean, authorization?: string, file: File,  }, options?: any) {
				const _params = {} as any;
				_params['forceOcr'] = params['forceOcr']
				_params['authorization'] = params['authorization']
				_params['file'] = params['file']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).confirmRetranslation(_params.forceOcr, _params.authorization, _params.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create stripe payment session and return url
     * @param {string} authorization 
     * @param {StripePaymentSessionRequest} stripePaymentSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public createStripePaymentSession(params: { authorization?: string, stripePaymentSessionRequest: StripePaymentSessionRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['stripePaymentSessionRequest'] = params['stripePaymentSessionRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).createStripePaymentSession(_params.authorization, _params.stripePaymentSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create stripe subscription session and return url
     * @param {string} authorization 
     * @param {StripeSubscriptionSessionRequest} stripeSubscriptionSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public createStripeSubscriptionSession(params: { authorization?: string, stripeSubscriptionSessionRequest: StripeSubscriptionSessionRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['stripeSubscriptionSessionRequest'] = params['stripeSubscriptionSessionRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).createStripeSubscriptionSession(_params.authorization, _params.stripeSubscriptionSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a file
     * @param {number} usageId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public downloadMyFile(params: { usageId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['usageId'] = params['usageId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).downloadMyFile(_params.usageId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Evaluate translation
     * @param {string} authorization 
     * @param {number} usageId 
     * @param {EvaluateTranslationRequest} evaluateTranslationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public evaluateTranslation(params: { authorization?: string, usageId: number, evaluateTranslationRequest: EvaluateTranslationRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['usageId'] = params['usageId']
				_params['evaluateTranslationRequest'] = params['evaluateTranslationRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).evaluateTranslation(_params.authorization, _params.usageId, _params.evaluateTranslationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a translated html url
     * @param {number} usageId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public getMyHtmlFileUrl(params: { usageId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['usageId'] = params['usageId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).getMyHtmlFileUrl(_params.usageId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of plans a user can apply
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public getMyPlans(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).getMyPlans(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a logged in user\'s profile
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public getMyProfile(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).getMyProfile(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a logged in user\'s usage record
     * @param {number} usageId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public getMyUsage(params: { usageId: number, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['usageId'] = params['usageId']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).getMyUsage(_params.usageId, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a logged in user\'s usage history
     * @param {string} authorization 
     * @param {number} [page] 
     * @param {boolean} [all] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public getMyUsages(params: { authorization?: string, page?: number, all?: boolean,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['page'] = params['page']
				_params['all'] = params['all']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).getMyUsages(_params.authorization, _params.page, _params.all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary login
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public login(params: { loginRequest: LoginRequest,  }, options?: any) {
				const _params = {} as any;
				_params['loginRequest'] = params['loginRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).login(_params.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary logout
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public logout(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).logout(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary remind password
     * @param {RemindRequest} remindRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public remind(params: { remindRequest: RemindRequest,  }, options?: any) {
				const _params = {} as any;
				_params['remindRequest'] = params['remindRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).remind(_params.remindRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset passsword
     * @param {string} authorization 
     * @param {ResetRequest} resetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public reset(params: { authorization?: string, resetRequest: ResetRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['resetRequest'] = params['resetRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).reset(_params.authorization, _params.resetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user\'s profile
     * @param {string} authorization 
     * @param {UpdateMyProfileRequest} updateMyProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public updateMyProfile(params: { authorization?: string, updateMyProfileRequest: UpdateMyProfileRequest,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				_params['updateMyProfileRequest'] = params['updateMyProfileRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).updateMyProfile(_params.authorization, _params.updateMyProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file
     * @param {string} sourceLang 
     * @param {string} targetLang 
     * @param {boolean} forceOcr 
     * @param {string} authorization 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyApi
     */
    public uploadMyFile(params: { sourceLang: string, targetLang: string, forceOcr: boolean, authorization?: string, file: File,  }, options?: any) {
				const _params = {} as any;
				_params['sourceLang'] = params['sourceLang']
				_params['targetLang'] = params['targetLang']
				_params['forceOcr'] = params['forceOcr']
				_params['authorization'] = params['authorization']
				_params['file'] = params['file']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return MyApiFp(this.configuration).uploadMyFile(_params.sourceLang, _params.targetLang, _params.forceOcr, _params.authorization, _params.file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Inquiry
         * @param {InquiryRequest} inquiryRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiry: async (inquiryRequest: InquiryRequest, authorization?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inquiryRequest' is not null or undefined
            assertParamExists('inquiry', 'inquiryRequest', inquiryRequest)
            const localVarPath = `/inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inquiryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Registration
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerRequest: RegisterRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('register', 'registerRequest', registerRequest)
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send error report
         * @param {ErrorReportRequest} errorReportRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report: async (errorReportRequest: ErrorReportRequest, authorization?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'errorReportRequest' is not null or undefined
            assertParamExists('report', 'errorReportRequest', errorReportRequest)
            const localVarPath = `/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(errorReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a verification email
         * @param {RequestVerificationRequest} requestVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestVerification: async (requestVerificationRequest: RequestVerificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestVerificationRequest' is not null or undefined
            assertParamExists('requestVerification', 'requestVerificationRequest', requestVerificationRequest)
            const localVarPath = `/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stripe webhooks
         * @param {string} stripeSignature 
         * @param {StripeRequest} stripeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripe: async (stripeSignature: string, stripeRequest: StripeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('stripe', 'stripeSignature', stripeSignature)
            // verify required parameter 'stripeRequest' is not null or undefined
            assertParamExists('stripe', 'stripeRequest', stripeRequest)
            const localVarPath = `/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeSignature !== undefined && stripeSignature !== null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary stripe_add_purchase webhooks
         * @param {string} stripeSignature 
         * @param {StripeAddPurchaseRequest} stripeAddPurchaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeAddPurchase: async (stripeSignature: string, stripeAddPurchaseRequest: StripeAddPurchaseRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('stripeAddPurchase', 'stripeSignature', stripeSignature)
            // verify required parameter 'stripeAddPurchaseRequest' is not null or undefined
            assertParamExists('stripeAddPurchase', 'stripeAddPurchaseRequest', stripeAddPurchaseRequest)
            const localVarPath = `/stripe_add_purchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeSignature !== undefined && stripeSignature !== null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripeAddPurchaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verification
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('verify', 'authorization', authorization)
            const localVarPath = `/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Inquiry
         * @param {InquiryRequest} inquiryRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inquiry(inquiryRequest: InquiryRequest, authorization?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inquiry(inquiryRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Registration
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerRequest: RegisterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send error report
         * @param {ErrorReportRequest} errorReportRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async report(errorReportRequest: ErrorReportRequest, authorization?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.report(errorReportRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request a verification email
         * @param {RequestVerificationRequest} requestVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestVerification(requestVerificationRequest: RequestVerificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestVerification(requestVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Stripe webhooks
         * @param {string} stripeSignature 
         * @param {StripeRequest} stripeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripe(stripeSignature: string, stripeRequest: StripeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripe(stripeSignature, stripeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary stripe_add_purchase webhooks
         * @param {string} stripeSignature 
         * @param {StripeAddPurchaseRequest} stripeAddPurchaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeAddPurchase(stripeSignature: string, stripeAddPurchaseRequest: StripeAddPurchaseRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeAddPurchase(stripeSignature, stripeAddPurchaseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verification
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verify(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Inquiry
         * @param {InquiryRequest} inquiryRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiry(inquiryRequest: InquiryRequest, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.inquiry(inquiryRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registration
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerRequest: RegisterRequest, options?: any): AxiosPromise<void> {
            return localVarFp.register(registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send error report
         * @param {ErrorReportRequest} errorReportRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report(errorReportRequest: ErrorReportRequest, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.report(errorReportRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a verification email
         * @param {RequestVerificationRequest} requestVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestVerification(requestVerificationRequest: RequestVerificationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.requestVerification(requestVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stripe webhooks
         * @param {string} stripeSignature 
         * @param {StripeRequest} stripeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripe(stripeSignature: string, stripeRequest: StripeRequest, options?: any): AxiosPromise<void> {
            return localVarFp.stripe(stripeSignature, stripeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary stripe_add_purchase webhooks
         * @param {string} stripeSignature 
         * @param {StripeAddPurchaseRequest} stripeAddPurchaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeAddPurchase(stripeSignature: string, stripeAddPurchaseRequest: StripeAddPurchaseRequest, options?: any): AxiosPromise<void> {
            return localVarFp.stripeAddPurchase(stripeSignature, stripeAddPurchaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verification
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify(authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.verify(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Inquiry
     * @param {InquiryRequest} inquiryRequest 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public inquiry(params: { inquiryRequest: InquiryRequest, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['inquiryRequest'] = params['inquiryRequest']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).inquiry(_params.inquiryRequest, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registration
     * @param {RegisterRequest} registerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public register(params: { registerRequest: RegisterRequest,  }, options?: any) {
				const _params = {} as any;
				_params['registerRequest'] = params['registerRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).register(_params.registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send error report
     * @param {ErrorReportRequest} errorReportRequest 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public report(params: { errorReportRequest: ErrorReportRequest, authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['errorReportRequest'] = params['errorReportRequest']
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).report(_params.errorReportRequest, _params.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a verification email
     * @param {RequestVerificationRequest} requestVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public requestVerification(params: { requestVerificationRequest: RequestVerificationRequest,  }, options?: any) {
				const _params = {} as any;
				_params['requestVerificationRequest'] = params['requestVerificationRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).requestVerification(_params.requestVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stripe webhooks
     * @param {string} stripeSignature 
     * @param {StripeRequest} stripeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public stripe(params: { stripeSignature: string, stripeRequest: StripeRequest,  }, options?: any) {
				const _params = {} as any;
				_params['stripeSignature'] = params['stripeSignature']
				_params['stripeRequest'] = params['stripeRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).stripe(_params.stripeSignature, _params.stripeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary stripe_add_purchase webhooks
     * @param {string} stripeSignature 
     * @param {StripeAddPurchaseRequest} stripeAddPurchaseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public stripeAddPurchase(params: { stripeSignature: string, stripeAddPurchaseRequest: StripeAddPurchaseRequest,  }, options?: any) {
				const _params = {} as any;
				_params['stripeSignature'] = params['stripeSignature']
				_params['stripeAddPurchaseRequest'] = params['stripeAddPurchaseRequest']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).stripeAddPurchase(_params.stripeSignature, _params.stripeAddPurchaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verification
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public verify(params: { authorization?: string,  }, options?: any) {
				const _params = {} as any;
				_params['authorization'] = params['authorization']
				// @ts-ignore
				_params.authorization = 'Bearer ' + ( params.authorization || Store.getInstance().getAccessToken())!
        return UserApiFp(this.configuration).verify(_params.authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

